import { queryOptions, useQuery } from '@tanstack/react-query'

import { getGisIssueDetail } from '../api/gisApi'

/**
 * Lazy issue drill-down. Gated on an issue id (the drawer mounts on selection). Keyed under the
 * `gis` namespace so it never collides with other systems' `/issues/{id}` caches. No keepPreviousData
 * — opening a different issue should show its own load state, not the previous issue's data.
 */
export const gisIssueDetailQueryOptions = (issueId: string) =>
  queryOptions({
    queryKey: ['gis', 'issue-detail', issueId] as const,
    queryFn: () => getGisIssueDetail(issueId),
    enabled: issueId.length > 0,
    staleTime: 1000 * 60, // 1m — an issue's event timeline turns over faster than site stats (2m)
  })

export function useGisIssueDetail(issueId: string) {
  return useQuery(gisIssueDetailQueryOptions(issueId))
}
